import React, { memo } from 'react'

import StyledLink from 'components/CommonUI/Link/Link'
import LeftArrow from 'components/CommonUI/svgIcons/LeftArrow'
import { routingConstants } from 'constants/routingConstants'

const ContentContainer = ({ children, withBack = false, className = '' }) => {
  return (
    <div className={`content_container ${className}`}>
      {withBack && (
        <StyledLink className="auth_back_button" to={routingConstants.auth}>
          <LeftArrow />
          <span className="button_text">Back to login</span>
        </StyledLink>
      )}
      {children}
    </div>
  )
}

export default memo(ContentContainer)
